module.exports = __webpack_public_path__ + "img/logo.c7898d34.jpg";